import axios from "axios";
import { useEffect, useState } from "react";
import localize from "../../../../common/localize";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import SignatureBox from "./SignatureBox";
import useGlobalContext from "../../../../hooks/useGlobalContext";

export default function FormSignatures({
  footerInformation,
  showSignatures,
  finalObservation,
  clientSignature,
  personalAssignedSignature,
  eventId
}) {
  const {EVENTS_API, config} = useGlobalContext();
  const [clientSignatureBlob, setClientSignatureBlob] = useState(undefined);
  const [personalAssignedSignatureBlob, setPersonalAssignedSignatureBlob] = useState(undefined);

  const getLeftPanelInformation = () => {
    return (
      <div className="flex flex-col" style={{ width: "100%" }}>
        <ReportSectionTitle title={localize.technical_concept} />
        <div
          className="report_section_without_top_border"
          style={
            finalObservation && finalObservation.length > 0
              ? { width: "100%", maxHeight: "92px", padding: "5px" }
              : { width: "100%", minHeight: "92px", padding: "5px" }
          }
        >
          {finalObservation && finalObservation.length > 0 && (
            <label className="report_little_text">{finalObservation}</label>
          )}
        </div>
      </div>
    );
  };

  const downloadEvidence = async (signatureField) => {
    const image = await axios({
      ...config,
      method: "get",
      responseType: "blob", // Force to receive data in a Blob Format
      url: `${EVENTS_API}/${eventId}/evidence/${signatureField.Id}/download`,
    });

    if (image?.data) {
      const blob = new Blob([image.data], {
        type: "application/octet-stream",
      });

      const urlBlob = URL.createObjectURL(blob);
      
      if (signatureField.EvidenceType === 5){
        setClientSignatureBlob(urlBlob);
        return;
      }

      setPersonalAssignedSignatureBlob(urlBlob);
    }
  };

  useEffect(() => {
    if (clientSignature) downloadEvidence(clientSignature);
  }, [clientSignature]);

  useEffect(() => {
    if (personalAssignedSignature) downloadEvidence(personalAssignedSignature);
  }, [personalAssignedSignature]);

  useEffect(() => {
    return () => {
      if (clientSignatureBlob) URL.revokeObjectURL(clientSignatureBlob);
      if (personalAssignedSignatureBlob) URL.revokeObjectURL(personalAssignedSignatureBlob);
    };
  }, [clientSignatureBlob, personalAssignedSignatureBlob]);

  return (
    <div className="flex flex-col">
      <div style={{ width: "100%" }}>{getLeftPanelInformation()}</div>

      <div
        style={{ flexDirection: "row-reverse", gap: "10px" }}
        className="w-full flex mt-2"
      >
        {showSignatures && (
          <div
            style={{
              display: "flex",
              alignContent: "space-evenly",
              gap: "10px",
              width: "70%",
            }}
          >
            <SignatureBox
              title={localize.personal_assigned_signature}
              subtitle={`${localize.name}: ${personalAssignedSignature ? personalAssignedSignature.Name : ''}`}
              imageBlob={personalAssignedSignatureBlob}
            />
            <SignatureBox
              title={localize.client_signature}
              subtitle={`${localize.name}: ${clientSignature ? clientSignature.Name : ''}`}
              imageBlob={clientSignatureBlob}
            />
          </div>
        )}

        {footerInformation?.length > 0 && (
          <div style={{ width: showSignatures ? "30%" : "100%" }}>
            <label
              style={{ wordWrap: "break-word", lineHeight: "10px" }}
              className="report_little_footer_text"
            >
              {footerInformation}
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
